import React, { useEffect } from "react";
import "../style.css";
import {
  commonHeaderStyle,
  commonStyle,
  displayCommaFormatter,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector, useDispatch } from "react-redux";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import { getEmailMasterData } from "./action";
import moment from "moment";

const Table = () => {
  const { emailMasterData } = useSelector((state) => state.emailMasterReducer);
  const dispatch = useDispatch();

  // Date formatter function
  const formatCreatedDate = (cell, row) => {
    if (row.created_date) {
      const formattedDate = moment(row.created_date).format(
        "DD/MM/YYYY HH:mm:ss"
      );
      return formattedDate;
    }
    return "--";
  };

  const subColumns = [
    {
      dataField: "Email",
      text: "Email",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "60%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "60%",
        display: "table-cell",
      },
      formatter: (cell, row) => displayNullFormatter(row, "Email"),
    },
    {
      dataField: "CREATED_AT",
      text: "Created Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
        width: "40%",
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "40%",
        display: "table-cell",
      },
      formatter: formatCreatedDate,
    },
  ];

  const Columns = [
    {
      dataField: "gstin",
      headerFormatter: () => (
        <>
          <div
            style={{
              width: "15.3%",
              // borderRight: "1px solid black",
            }}
          >
            GSTIN
          </div>
        </>
      ),
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const padding = "0";
        const border = "none";
        return { fontFamily, fontSize, fontWeight, padding, border };
      },
      headerStyle: {
        display: "flex",
        paddingTop: "15px",
      },
      formatter: (cell, row, i) => {
        return (
          <>
            <div style={{ width: "100%" }}>
              <Accordion style={{ width: "100%" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  style={{
                    display: "block",
                    minHeight: "0px",
                    height: "28px",
                    position: "relative",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="email-master-accordion"
                >
                  <div
                    style={{ width: "100%", display: "flex" }}
                    onClick={function (e) {
                      e.stopPropagation();
                    }}
                  >
                    <Typography
                      className="email-master-accordion-text"
                      style={{
                        width: "16.7%",
                      }}
                    >
                      {displayNullFormatter(row, "gstin")}
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <BootstrapTable
                    keyField="Email"
                    data={row.dataJson ? row.dataJson : []}
                    columns={subColumns}
                    rowStyle={rowStyle2}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getEmailMasterData());
  }, []);

  return (
    <>
      {emailMasterData?.length > 0 ? (
        <>
          <div
            className="light-border-notice-table"
            style={{ marginTop: "1em" }}
          >
            <BootstrapTable
              keyField="gstin"
              data={emailMasterData}
              columns={Columns}
              rowStyle={rowStyle2}
            />
          </div>
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
